import { useState, useEffect, useContext } from 'react';
import { useFormContext } from 'react-hook-form';
import { Grid, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { formStyle } from '../../TransitionStyles';
import FormTitle from '../FormTitle';
import { fetchStaffDetails } from '../../../../../api/transitions';
import { enqueueSnackbar } from '../../../../../reusable-components/snackbar';
import { TransitionViewContext } from '../../Transition/_TransitionViewContext';

const getRequestKey = (transitionFacilityId, diffDeptId) => `${transitionFacilityId ?? ''}_${diffDeptId ?? ''}`;

DiffDeptInputsWithFetch.propTypes = {
  diffDeptId: PropTypes.string,
};

export default function DiffDeptInputsWithFetch({ diffDeptId }) {
  const { getValues } = useFormContext();
  const { diffDeptStaffCache, setDiffDeptStaffCache } = useContext(TransitionViewContext);
  const [diffDeptStaff, setDiffDeptStaff] = useState([]);

  useEffect(() => {
    let isActive = true;

    const load = async () => {
      const transitionFacilityId = getValues('transitionFacilityId');
      const requestKey = getRequestKey(transitionFacilityId, diffDeptId);

      if (diffDeptStaffCache.has(requestKey)) {
        if (isActive) setDiffDeptStaff(diffDeptStaffCache.get(requestKey));
        return;
      }

      try {
        const response = await fetchStaffDetails(transitionFacilityId, diffDeptId);
        const data = response?.data ?? [];
        setDiffDeptStaffCache((prev) => prev.set(requestKey, data));

        if (isActive) {
          setDiffDeptStaff(data);
        }
      } catch {
        enqueueSnackbar('Failed to fetch staff details', { variant: 'error' });
      }
    };

    load();

    return () => {
      isActive = false;
    };
  }, [diffDeptId]);

  const rowsToRender = diffDeptStaff.length > 0 ? diffDeptStaff : [{}];

  return rowsToRender.map((staff, index) => (
    <Grid key={`${diffDeptId}${index}`} container spacing={1} sx={{ mt: 1 }}>
      <Grid item xs={12} sm={6} lg={3}>
        <FormTitle fieldAttributes={{ questionTitle: 'First name' }} />
        <TextField fullWidth size="small" type="text" disabled value={staff?.firstName ?? ''} sx={formStyle} />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <FormTitle fieldAttributes={{ questionTitle: 'Last name' }} />
        <TextField fullWidth size="small" type="text" disabled value={staff?.lastName ?? ''} sx={formStyle} />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <FormTitle fieldAttributes={{ questionTitle: 'Cell phone' }} />
        <TextField fullWidth size="small" type="text" disabled value={staff?.cellPhone ?? ''} sx={formStyle} />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <FormTitle fieldAttributes={{ questionTitle: 'Email' }} />
        <TextField fullWidth size="small" type="text" disabled value={staff?.email ?? ''} sx={formStyle} />
      </Grid>
    </Grid>
  ));
}
